const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');
const storage = require('utilities/storage');

// @ utils
const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const SanitizeHelper = require('utilities/sanitizeHelper');
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const Flag = require('components/broker/commons/flag/flag');
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');

// @ constants
const {
    BROKER_ADVANCED_SEARCH_ID_CLASSIFICATION_TYPE_ADMINISTRATOR,
    BROKER_ADVANCED_SEARCH_ID_CLASSIFICATION_TYPE_CATEGORY,
    BROKER_SEARCH_VARIATION_DECIMALS,
    BROKER_LARGE_FLAG_SIZE,
    DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT,
    PRODUCT_TYPE_ETF,
} = require('constants/index');

const MICCODE_CONVERSION = require('constants/miccodes');

class BrokerAdvancedSearchETFsResultsRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    componentWillUnmount() {
        storage.localStorage.set(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, 1);
    }

    getDetails(item, typeCode) {
        const classificationTypes = item.getIn([
            'classificationTypes',
            'componentsStockClassificationTypeItem',
            'stockClassificationTypeItem'
        ]);
        return classificationTypes
            .filter(classification => classification.get('idClassificationType') === typeCode)
            .reduce((prev, curr) => {
                return curr.getIn([
                    'stockClassifications',
                    'componentsStockClassificationItem',
                    'stockClassificationItem',
                    0,
                    'description'
                ]);
            }, '');
    }

    buildMarketLabel(miccode) {
        const market = MICCODE_CONVERSION.find(market => market.MIC == miccode);

        if (market) {
            const city = toFirstUppercase(market.CITY);
            return `${market.MIC}, ${city} (${market.ISO_COUNTRY_CODE})`;
        }
    }

    handleProductSelect() {
        const stockQuote = this.props.item.get('stockQuote');
        const product = {
            id: {
                isin: stockQuote.get('instrumentId'),
                iso: stockQuote.get('miccode')
            },
            label: stockQuote.get('instrument')
        };

        this.props.onHandleProductSelect(product);
    }

    render() {
        const { item, immStocksContracts, rowIndex, showModal, watchlistEnabled } = this.props;

        const stockQuote = item.get('stockQuote');
        const instrumentId = stockQuote.get('instrumentId').trim();
        const instrument = stockQuote.get('instrument').trim();
        const miccode = stockQuote.get('miccode').trim();
        const productName = stockQuote.get('instrument').trim();
        const currency = stockQuote.get('currencyCode').trim();
        const countryCode = stockQuote.getIn(['country', 'id']);

        const issuer = this.getDetails(item, BROKER_ADVANCED_SEARCH_ID_CLASSIFICATION_TYPE_ADMINISTRATOR);
        const market = this.buildMarketLabel(miccode);
        const category = this.getDetails(item, BROKER_ADVANCED_SEARCH_ID_CLASSIFICATION_TYPE_CATEGORY);

        const ytd = `${formatAmount(stockQuote.get('yearChangePercentage'))} %`;

        const notAvailableText = formatText('broker-searchResultsNotAvailableData');
        const buyLabel = watchlistEnabled ? formatText(`broker-searchResultsWatchListBuyLabel`) : formatText(`broker-searchResultsBuyLabel`);
        const buyButtonSize = watchlistEnabled ? "compact" : "regular";
        const buyUrl = `/myprofile/broker/etfsBuy/${instrumentId}/${miccode}`;
        const etfsFileUrl = `/myprofile/broker/etfsProductFile/${instrumentId}/${miccode}`;
        const buttonText = 'Seleccionar';
        const watchlistId = item.get('watchlistId');
        const productKey = item.get('productKey');
        const starIconClasses = classNames('broker-search-results__star', {
            'broker-search-results__star--disabled': !watchlistId
        });
        const emptyContracts = immStocksContracts.isEmpty();
        let button;

        if (this.props.isModal) {
            button = (
                <OKButton modifier="secondary" onClick={this.handleProductSelect}>
                    {buttonText}
                </OKButton>
            );
        } else {
            if (emptyContracts) {
                button = (
                    <OKButton modifier="secondary" onClick={showModal}>
                        {buyLabel}
                    </OKButton>
                );
            } else {
                button = (
                    <BrokerMiFIDUSPersonButton
                        modifier="secondary"
                        onClick={() => this.props.onBuyClick(buyUrl)}
                        size={buyButtonSize}
                        isinId={instrumentId}
                        marketId={miccode}>
                        {buyLabel}
                    </BrokerMiFIDUSPersonButton>
                );
            }
        }
        const watchlistButton = (
            <span>
                <OKButton
                    modifier="ghost"
                    size="small"
                    autoHeight={true}
                    onClick={() => { !watchlistId ? this.props.onWatchlistClick(instrumentId, miccode, PRODUCT_TYPE_ETF, productKey) : this.props.deleteProductFromList(watchlistId, instrumentId, miccode, productName, watchlistId, false, PRODUCT_TYPE_ETF, productKey)}}
                >
                    <i className={starIconClasses}></i>
                </OKButton>
            </span>
        );

        const watchListToolTipInitialVal = Number(storage.localStorage.get(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT)) === 0;
        const isTooltipVisible = (rowIndex == 0 && watchListToolTipInitialVal && watchlistEnabled);
        const watchlistBtnTooltip = watchlistEnabled && (
            <OKTooltip
                target={watchlistButton}
                content="brokerWatchList-brokerWatchList_tooltip"
                isVisible={isTooltipVisible}
            />
        );

        return (
            <OKTableRow>
                <OKTableCell className="broker-serach-results__table-cell broker-search-results__table-first-column broker-search-results__table-cell--bold">
                    <OKLink to={etfsFileUrl}>
                        {SanitizeHelper.sanitizeData(instrument)}
                    </OKLink>
                </OKTableCell>
                <OKTableCell>
                    <span className="broker-search-results__market-flag">
                        <Flag countryCode={countryCode} pixelsSize={BROKER_LARGE_FLAG_SIZE} />
                    </span>
                    {market || notAvailableText}
                </OKTableCell>
                <OKTableCell>
                    {issuer || notAvailableText}
                </OKTableCell>
                <OKTableCell>
                    {category || notAvailableText}
                </OKTableCell>
                <OKTableCell alignment="center">
                    {currency}
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    className="broker-search-results__variation--etfs"
                >
                    <StockExchangeIndexVariation
                        variationPts={formatAmount(stockQuote.get('netChangePrice'), undefined, BROKER_SEARCH_VARIATION_DECIMALS)}
                        variationPerc={formatAmount(stockQuote.get('netChangePercentage'))}
                    />
                </OKTableCell>
                <OKTableCell alignment="center">
                    {ytd}
                </OKTableCell>

                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-cell--action"
                >
                    <div className="broker-search-results__action-group">
                        {watchlistBtnTooltip}
                        {button}
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }
}

BrokerAdvancedSearchETFsResultsRow.propTypes = {
    deleteProductFromList: PropTypes.func,
    isModal: PropTypes.bool,
    item: PropTypes.object,
    onBuyClick: PropTypes.func,
    onHandleProductSelect: PropTypes.func,
    onWatchlistClick: PropTypes.func,
    selectedType: PropTypes.string,
    immStocksContracts: PropTypes.object,
    showModal: PropTypes.func.isRequired,
    rowIndex: PropTypes.number,
    watchlistEnabled: PropTypes.bool
};
    module.exports = {
        constructor: BrokerAdvancedSearchETFsResultsRow,
        BrokerAdvancedSearchETFsResultsRow: connect(
            state => ({
                immStocksContracts: state.brokerStocksContract

            }),{
                showModal: brokerNoStockAccountModalActions.showModal,
            })(BrokerAdvancedSearchETFsResultsRow)
    };
